import React, { useEffect, useState } from 'react';
const NAMES = ['James', 'Michael', 'David', 'Ryan', 'Emma', 'Sarah', 'Robert', 'Daniel', 'Matthew', 'Andrew', 'Chris', 'Jason', 'Kevin', 'Tom', 'Luke', 'George', 'Paul', 'Mark', 'Liam', 'Ethan', 'Olivia', 'Sophie', 'Emily', 'Hannah', 'Laura', 'Grace', 'Chloe'];
const CITIES = ['London 🇬🇧', 'Manchester 🇬🇧', 'New York 🇺🇸', 'Chicago 🇺🇸', 'Los Angeles 🇺🇸', 'Toronto 🇨🇦', 'Vancouver 🇨🇦', 'Sydney 🇦🇺', 'Melbourne 🇦🇺', 'Brisbane 🇦🇺', 'Auckland 🇳🇿', 'Dublin 🇮🇪', 'Birmingham 🇬🇧', 'Boston 🇺🇸', 'Calgary 🇨🇦', 'Perth 🇦🇺', 'Glasgow 🇬🇧', 'Houston 🇺🇸', 'Ottawa 🇨🇦', 'Wellington 🇳🇿'];
const PRODUCTS = [{
  name: 'Basketball Ready 360 + Pro Tactical Kit',
  emoji: '🏆'
}, {
  name: 'Basketball Ready 360',
  emoji: '🏀'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-213">
      <div className="bg-white border border-[#E5E5EA] rounded-2xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-214">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-[#5A5A66] hover:text-[#0A0A0A] transition-colors p-1" aria-label="Close notification" data-id="element-215">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-216">
          <div className="w-2 h-2 bg-[#00C853] rounded-full animate-pulse" data-id="element-217" />
          <span className="text-[#00C853] text-[10px] font-black uppercase tracking-widest" data-id="element-218">
            Verified purchase
          </span>
        </div>
        <p className="text-[#0A0A0A] text-sm mb-1 font-medium" data-id="element-219">
          <span className="font-black" data-id="element-220">
            {notification.name} {notification.initial}.
          </span>{' '}
          from {notification.city}
        </p>
        <p className="text-[#5A5A66] text-sm mb-2 font-medium" data-id="element-221">
          purchased{' '}
          <span className="text-[#FF6B00] font-black" data-id="element-222">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-[#5A5A66] opacity-70 text-xs font-bold" data-id="element-223">
          {notification.timeAgo} minutes ago
        </p>
      </div>
    </div>;
}